/**
 * プレミアム限定機能を押下した際のモーダルの状態
 * @property {boolean} isVisible モーダルの状態[true: 表示, false: 表示しない]
 */
const PremiumModalStore = {
  namespaced: true,
  state: {
    isVisible: false,
  },
  getters: {
    /* @returns {boolean} モーダルが表示されるなら真 */
    isVisible(state) {
      return state.isVisible;
    },
  },
  mutations: {
    /**
     * モーダル表示
     * @returns {void}
     */
    show(state) {
      state.isVisible = true;
    },
    /**
     * モーダル非表示
     * @returns {void}
     */
    hide(state) {
      state.isVisible = false;
    },
  },
};
export default PremiumModalStore;
